import axiosInstance from "../auth/FetchInterceptor";
import {
    REPORT_ACCOUNT_CHART_REVENUE,
    REPORT_ACCOUNT_REVENUE,
    REPORT_CHART_REVENUE,
    REPORT_REVENUE,
    REPORT_STATUS_ORDER,
    REPORT_TOP_EMPLOYEE,
    REPORT_TOP_PRODUCT,
    REPORT_REVENUE_V2,
    REPORT_TIME_V2,
    REPORT_TYPE_ORDER,
    REPORT_TIME_PAYMENT_V2,
    REPORT_REWARD_V2,
    ORDER_WAREHOUSE_REPORT_V2,
    CASHBOOK_RECEIPT_REPORT,
    WAREHOUSE_RECEIPT_REPORT_V2,
    WAREHOUSE_REPORT_BY_TIME,
    REPORT_CHART_PARTNER,
    SEARCH_ORDER_PARTNER,
    CASHBOOK_RECEIPT_REPORT_PARTNER,
    WAREHOUSE_REPORT_PARTNER,
    REPORT_CHART_STORE_TOTAL_V2,
    REPORT_CHART_DISCOUNT_STORE,
} from "constants/ApiConstant";

const ReportService = {};

ReportService.reportRevenue = function () {
    return axiosInstance.get(REPORT_REVENUE, null);
};

ReportService.reportTopProduct = function (data) {
    return axiosInstance.post(REPORT_TOP_PRODUCT, data);
};

ReportService.reportStatusOrder = function (data) {
    return axiosInstance.post(REPORT_STATUS_ORDER, data);
};

ReportService.reportTopEmployee = function (data) {
    return axiosInstance.post(REPORT_TOP_EMPLOYEE, data);
};

ReportService.reportChartRevenue = function (data) {
    const { storeId, listStoreId, ...payload } = data || {};

    return axiosInstance.post(REPORT_CHART_REVENUE, {
        ...payload,
        listStoreId: listStoreId ?? (storeId ? [storeId] : []),
    });
};

ReportService.reportAccountRevenue = function (data) {
    return axiosInstance.post(REPORT_ACCOUNT_REVENUE, data);
};

ReportService.reportAccountChartRevenue = function (data) {
    return axiosInstance.post(REPORT_ACCOUNT_CHART_REVENUE, data);
};

ReportService.reportRevenueV2 = function (data) {
    return axiosInstance.post(REPORT_REVENUE_V2, data);
};

ReportService.reportTimeV2 = function (data) {
    return axiosInstance.post(REPORT_TIME_V2, data);
};

ReportService.reportTypeOrder = function (data) {
    return axiosInstance.post(REPORT_TYPE_ORDER, data);
};

ReportService.reportTimePaymentV2 = function (data) {
    return axiosInstance.post(REPORT_TIME_PAYMENT_V2, data);
};

ReportService.reportRewardV2 = function (data) {
    return axiosInstance.post(REPORT_REWARD_V2, data);
};

ReportService.orderWarehouseReportV2 = function (data) {
    return axiosInstance.post(ORDER_WAREHOUSE_REPORT_V2, data);
};

ReportService.cashbookReceiptReport = function (data) {
    return axiosInstance.post(CASHBOOK_RECEIPT_REPORT, data);
};

ReportService.warehouseReceiptReportV2 = function (storeId, isPartnerCurrency) {
    return axiosInstance.get(`${WAREHOUSE_RECEIPT_REPORT_V2}/${storeId}/${isPartnerCurrency}`);
};

ReportService.warehouseReportByTime = function (data) {
    return axiosInstance.post(WAREHOUSE_REPORT_BY_TIME, data);
};

ReportService.reportChartPartner = function (data) {
    return axiosInstance.post(REPORT_CHART_PARTNER, data);
};

ReportService.searchOrderPartner = function (data) {
    return axiosInstance.post(SEARCH_ORDER_PARTNER, data);
};

ReportService.cashbookReceiptReportPartner = function (data) {
    return axiosInstance.post(CASHBOOK_RECEIPT_REPORT_PARTNER, data);
};

ReportService.warehouseReportPartner = function (data) {
    return axiosInstance.post(WAREHOUSE_REPORT_PARTNER, data);
};

ReportService.reportChartStoreTotalV2 = function (data) {
    return axiosInstance.post(REPORT_CHART_STORE_TOTAL_V2, data);
};

ReportService.reportChartDiscountStore = function (data) {
    return axiosInstance.post(REPORT_CHART_DISCOUNT_STORE, data);
};
export default ReportService;
